// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"46053682","160":"e82e72de","208":"5c718663","293":"02a17dca","453":"ed3810f9","516":"d96d70d8","519":"ed78c0cb","917":"2c69ff05","946":"c9f19d0c"}[chunkId] + ".chunk.js";
};